/**
 * User: Rob Richard
 * Date: 1/14/15
 * Time: 1:26 PM
 */

'use strict';

var PercentAdjustment = require('bunsen/models/ecomm/PercentAdjustment');
var FlatAdjustment = module.exports = PercentAdjustment.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var FinancialAmount = require('bunsen/models/FinancialAmount');

_.extend(FlatAdjustment.prototype, {
    relations: PercentAdjustment.prototype.relations.concat([{
        key: 'rate',
        relatedModel: FinancialAmount,
        type: Backbone.One
    }])
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/FlatAdjustment.js
// module id = 2641
// module chunks = 63